/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

/**
 * The HomeAway fork of this modifies some of this code to fit our ESLint rules
 *
 * It also has a custom method for determing Dev environment as the original
 * __DEV__ variable is not exported with React.
 */

let lowPriorityWarning = () => {
    return false;
};

const haFork = {
    /** Check if ADL is set up correctly within app, HomeAway specific */
    hasADL: () => {
        if (
            typeof window !== 'undefined' &&
            window.analyticsdatalayer &&
            window.analyticsdatalayer.appenvironment
        ) {
            const env = window.analyticsdatalayer.appenvironment;

            return env === 'dev' || env === 'test';
        }

        return false;
    },

    /** Check if window exists */
    hostExists: () => {
        if (
            typeof window !== 'undefined' &&
            window.location &&
            window.location.host
        ) {
            return true;
        }

        return false;
    },

    /** Check if running on a local HomeAway dev environment */
    isLocalDevHost: (host) => {
        if (host.indexOf('localhost') > -1 || host.indexOf('0.0.0.0') > -1) {
            return true;
        }

        return false;
    },

    /** HomeAway-ey way of looking if user is in dev environment */
    isDevEnv: () => {
        if (haFork.hasADL()) {
            return true;
        }

        if (haFork.hostExists()) {
            const host = window.location.host;

            return haFork.isLocalDevHost(host);
        }

        return false;
    }
};

if (haFork.isDevEnv()) {
    const printWarning = function(format, ...args) {
        let argIndex = 0;
        const message = `Warning: ${format.replace(
            /%s/g,
            () => args[argIndex++]
        )}`;

        if (typeof console !== 'undefined') {
            console.warn(message); // eslint-disable-line no-console
        }
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {
            return x;
        }
    };

    lowPriorityWarning = function(condition, format, ...args) {
        if (typeof format === 'undefined') {
            throw new Error(
                '`warning(condition, format, ...args)` requires a warning ' +
                    'message argument'
            );
        }

        if (condition) {
            printWarning(format, ...args);
        }

        return true;
    };
}

export {lowPriorityWarning, haFork};
